import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EquipmentDepot } from "../../data/equipment-depots/types";
import * as dataActions from "../../data/equipment-depots";

const prefix = "app/equipment-depot-dialog";

export type FormData = {
  id?: string;
  name: string;
  // Filled from the place search, never typed by hand.
  address: string | null;
  postcode: string | null;
  city: string | null;
  country: string | null;
  lat: number | null;
  lon: number | null;
  note: string | null;
};

type State = {
  open: boolean;
  initialFormData: FormData | null;
};

const initialState: State = {
  open: false,
  initialFormData: null,
};

export const getEmptyFormData = (): FormData => ({
  name: "",
  address: null,
  postcode: null,
  city: null,
  country: null,
  lat: null,
  lon: null,
  note: null,
});

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {
    addEquipmentDepot(state) {
      state.open = true;
      state.initialFormData = getEmptyFormData();
    },
    editEquipmentDepot(state, action: PayloadAction<EquipmentDepot>) {
      // The form is the depot minus `archived`, which the form never edits -
      // archiving is its own action from the depot register.
      const { archived, ...depot } = action.payload;
      state.open = true;
      state.initialFormData = depot;
    },
    close(state) {
      state.open = false;
      state.initialFormData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(dataActions.addEquipmentDepot.fulfilled, (state) => {
      state.open = false;
      state.initialFormData = null;
    });
    builder.addCase(dataActions.updateEquipmentDepot.fulfilled, (state) => {
      state.open = false;
      state.initialFormData = null;
    });
  },
});

export default slice.reducer;
export const { addEquipmentDepot, editEquipmentDepot, close } = slice.actions;
